import { useNavigate } from "react-router-dom";

const HeroBanner = () => {
  const navigate = useNavigate();

  return (
    <div className="relative h-screen max-h-[800px] min-h-[600px] bg-black">
      {/* Desktop background image */}
     <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            // "url('https://images.unsplash.com/photo-1523381210434-271e8be1f52b?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80')",
            // "url('/images/bgnew.jpeg')"
            "url('https://images.pexels.com/photos/8483488/pexels-photo-8483488.jpeg')",
        }}
      >
        <div className="absolute inset-0 bg-black/30" />
      </div>

      {/* Mobile background image */}
      <div
        className="block sm:hidden bg-cover bg-center h-[60vh] w-full absolute top-0 left-0"
        style={{ backgroundImage: "url('/images/bgmobile.jpeg')" }}
      >
        <div className="absolute inset-0 bg-black/30" />
      </div>

      {/* Content */}
      <div className="relative h-full flex items-center justify-center text-center text-white px-4">
        <div className="max-w-3xl">
          <h1 className="text-5xl md:text-7xl font-light mb-6 tracking-tight">
            Handcrafted <span className="font-semibold">Embroidery</span>
          </h1>
          <p className="text-xl md:text-2xl mb-10 text-gray-100 font-light">
            Discover the artistry of hand‑embroidered shirts, made in India with love.
          </p>
          <button
            onClick={() => navigate("/products")}
            className="border-2 border-white text-white px-8 py-3 text-base uppercase tracking-widest hover:bg-white hover:text-black transition-all duration-300 md:px-12 md:py-4 md:text-lg"
            // className="border-2 border-white text-white px-12 py-4 text-lg uppercase tracking-widest hover:bg-white hover:text-black transition-all duration-300"
          >
            Explore Collection
          </button>
        </div>
      </div>
    </div>
  );
};

export default HeroBanner;